import React from "react";
import { AppRouter } from "./Routes";

const App = () => {
  return <AppRouter />;
};

export default App;
